{
  "name": "Pedal Harp 84edo subset Nicholson",
  "description": "22-tone layout for Thomas Nicholson's pedal harp scordatura. The diatonic notes are tuned in 7edo and the pedal combinations generate a subset of 84edo (12*x7).",
  "scale": [
    "5\\84",
    "-5\\84",
    "7\\84",
    "12\\84",
    "17\\84",
    "29\\84",
    "19\\84",
    "24\\84",
    "36\\84",
    "41\\84",
    "31\\84",
    "43\\84",
    "48\\84",
    "53\\84",
    "0.",
    "55\\84",
    "60\\84",
    "928.571429",
    "77\\84",
    "67\\84",
    "72\\84",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "NicholsonHarp",
  "built_in_group": "Scordatura",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "C+43",
    "C+14",
    "C−29",
    "C+43",
    "D+14",
    "E−14",
    "F−43",
    "E+14",
    "E−14",
    "F−43",
    "F+29",
    "F−14",
    "G−43",
    "G+29",
    "G",
    "",
    "G+29",
    "A",
    "B−29",
    "B+43",
    "B",
    "B−29"
  ],
  "note_colors": [
    "#ffadad",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "999999",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff"
  ],
  "equivSteps": 22,
  "fundamental": 440,
  "reference_degree": 17,
  "center_degree": 0,
  "rSteps": 7,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
